import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FilterMatchMode } from 'primeng/api';

@Component({
  selector: 'app-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.css']
})
export class DateFilterComponent implements OnInit {
  @Input() field: any;
  @Input() table: any;
  @Input() filters: any;
  filterFormGroup: FormGroup;
  @Output() applyFilter: EventEmitter<any> = new EventEmitter<any>();
  @Output() filterDate: EventEmitter<any> = new EventEmitter<any>();
  matchModeOptions = [
    { label: "Equals", value: "custom-equals" },
    { label: "Not Equals", value: "not-equals" },
    { label: "Greater Than", value: "date-after" },
    { label: "Less Than", value: "date-before" },
  ];
  showAddRuleButton:boolean = false;
  @Input() filterData: any;
  constructor(private _fb: FormBuilder) { }

  ngOnInit(): void {
    this.initialSetup();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['filterData'].currentValue == undefined){
      this.initialSetup();
    }
  }

  initialSetup() {
    this.filterFormGroup = this._fb.group({
      customquery: this._fb.array([
        this._fb.group({
          matchModeControl: new FormControl('custom-equals'),
          valueControl: new FormControl(null, [Validators.required])
        })
      ])
    })

    this.showAddRuleButton = false;
  }

  addCustomQuery() {
    const control = <FormArray>this.filterFormGroup.controls['customquery'];
    control.push( this._fb.group({
      matchModeControl: new FormControl('custom-equals'),
      valueControl: new FormControl(null, [Validators.required])
    }));
  }

  removeCustomQuery(i: number) {
    const control = <FormArray>this.filterFormGroup.controls['customquery'];
    control.removeAt(i);
    this.showAddRuleBtn();
    //this.apply(this.filterFormGroup, this.field)
  }

  showAddRuleBtn(){
    const value = (<FormArray>this.filterFormGroup.controls['customquery']).at(0).value.matchModeControl;
    if(value == 'date-after'){
      this.showAddRuleButton = true;
    }else{
      this.showAddRuleButton = false;
    }
  }

  apply(formGroup, fieldName) {
    let formArray = formGroup.value;
    this.filterData = formArray.customquery
    this.table.filters[fieldName][0].value = this.filterData[0].valueControl;
    this.table.filters[fieldName][0].matchMode = this.filterData[0].matchModeControl;
    this.table.filters[fieldName][0].operator = 'and';
    this.filters = this.table.filters;
    this.filterDate.emit(this.filterData);
    //this.applyFilter.emit();
  }

  clear(fieldName) {
    this.initialSetup();
    for (let i = 0; i < this.table.filters[fieldName].length; i++) {
      this.table.filters[fieldName][i].value = null;
      this.table.filters[fieldName][i].matchMode = null;
      this.table.filters[fieldName][i].operator = null;
    }
    this.filters = this.table.filters;
    this.filterDate.emit(undefined)
   // this.applyFilter.emit();
  }

  filterOpen(form: FormGroup, fieldName, control1, control2) {
    if (this.filterData != undefined) {
      this.initialSetup();
      const control = <FormArray>this.filterFormGroup.controls['customquery'];
      if (this.filterData.length == 2) {
        this.addCustomQuery();
      }
      if (this.table.filters[fieldName] != undefined && this.table.filters[fieldName][0].value != undefined) {
        for (let i = 0; i < this.filterData.length; i++) {
          control.controls[i]['controls'][control1].setValue(this.filterData[i].matchModeControl)
          control.controls[i]['controls'][control2].setValue(this.filterData[i].valueControl)
        }
      }
      this.showAddRuleBtn()
    }else{
      this.initialSetup();
    }
  }

  test(){
    alert("ok")
  }
}
